/* eslint-disable react/jsx-no-bind, react/no-multi-comp */
import React, {useRef, useState} from "react";
import BillingInformationForm from "./BillingInformation/BillingInformationForm";
import CollapseIcon from "./Icons/CollapseIcon";
import ContactInformationForm from "./ContactInformation/ContactInformationForm";
import DisplayContact from "./DisplayContact";
import ErrorDisplay from "./ErrorDisplay";
import ExpandIcon from "./Icons/ExpandIcon";
import LockIcon from "./Icons/LockIcon";
import PropTypes from "prop-types";

const CheckoutContainer = ({
  contactFromSession,
  productDescriptorId,
  recaptchaSiteKey,
  retailPrice
}) => {

  const billingInfoRef = useRef();

  const hasContactInfo = Boolean(contactFromSession);

  const [
    displayError,
    setDisplayError
  ] = useState(null);

  const [
    shippingInfoDisplayed,
    setShippingInfoDisplay
  ] = useState(!hasContactInfo);

  const [
    billingInfoDisplayed,
    setBillingInfoDisplay
  ] = useState(hasContactInfo);

  const [
    contact,
    setContact
  ] = useState(contactFromSession);

  const clearContact = () => {
    setContact(null);
  };

  const handleSuccessfulContactCreation = (contactInfo) => {
    setContact(contactInfo);
    setShippingInfoDisplay(false);
    setBillingInfoDisplay(true);
    billingInfoRef.current.scrollIntoView(false);
  };

  // control errors from the parent component
  // pass the error into the individual components they belong to
  // set the error in individual components
  const removeError = () => {
    setDisplayError(null);
  };

  const errorComponent = () => (
    <ErrorDisplay
      errorParams={displayError}
      removeError={removeError}
    />
  );

  const toggleShippingDisplay = () => {
    setShippingInfoDisplay(prev => !prev);
  };

  const toggleBillingDisplay = () => {
    setBillingInfoDisplay(prev => !prev);
  };

  const {
    "id": contactId,
    "first_name": firstName,
    "last_name": lastName
  } = contact || {};

  return (
    <div className="checkout-container">
      <div
        className="section-header"
        onClick={toggleShippingDisplay}
      >
        <hr />
        <span className="bold">
          Shipping Information
        </span>
        <span className="collapse-expand">
          {shippingInfoDisplayed ? <CollapseIcon /> : <ExpandIcon />}
        </span>
      </div>
      <ContactInformationForm
        clearContact={clearContact}
        displayed={shippingInfoDisplayed}
        error={displayError && displayError.component === "contactInformationForm" ? errorComponent() : null}
        handleDisplayErrors={setDisplayError}
        handleSuccessfulContactCreation={handleSuccessfulContactCreation}
      />
      { contact && !shippingInfoDisplayed &&
        <div className="contact-display-container">
          <DisplayContact contact={contact} />
          <div
            className="underline"
            onClick={toggleShippingDisplay}
          >
            Change
          </div>
        </div>
      }
      <div
        className="section-header"
        onClick={toggleBillingDisplay}
        ref={billingInfoRef}
      >
        <hr />
        <div className="flex-between">
          <div className="flex">
            <LockIcon
              classes="inline mr4"
              height={20}
              width={20}
            />
            <span className="bold">
              Billing Information / Place Order
            </span>
          </div>
          <span className="collapse-expand">
            {billingInfoDisplayed ? <CollapseIcon /> : <ExpandIcon />}
          </span>
        </div>
      </div>
      <BillingInformationForm
        contactId={contactId}
        displayed={billingInfoDisplayed}
        error={displayError ? errorComponent() : null}
        firstName={firstName}
        handleDisplayErrors={setDisplayError}
        lastName={lastName}
        productDescriptorId={productDescriptorId}
        recaptchaSiteKey={recaptchaSiteKey}
        retailPrice={retailPrice}
      />
    </div>
  );
};

CheckoutContainer.defaultProps = {
  "contactFromSession": {},
  "recaptchaSiteKey": ""
};

CheckoutContainer.propTypes = {
  "contactFromSession": PropTypes.object,
  "productDescriptorId": PropTypes.number.isRequired,
  "recaptchaSiteKey": PropTypes.string,
  "retailPrice": PropTypes.number.isRequired
};

export default CheckoutContainer;
